/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';

export default [
  {
    name: 'pubg',
    path: '/pubg',
    meta: {},
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'pubg_chicken' },
    children: [
      {
        name: 'pubg_chicken',
        path: 'chicken',
        meta: { title: '吃鸡图生成' },
        component: () => import('@/views/pubg/index.vue'),
      },
    ],
  },
] as RouteConfig[];
